import { WidgetSizeT } from "../../Storecast/Storecast/localTypes/WidgetSizeT";
import { EmptyPositionT } from "../../Storecast/Storecast/EmptyPositions/EmptyPosType";
import {
  DrawerNavigationProp,
  createDrawerNavigator,
} from "@react-navigation/drawer";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";

export type OrgSpaceWidgetAddBaseParams = {
  spaceId: string;
  position: EmptyPositionT;
  maxSize: WidgetSizeT;
  workspaceId: string;
};
type OrgSpaceWidgetAddDrawerParamList = {
  OrgSpaceWACategoryNote: OrgSpaceWidgetAddBaseParams;
  OrgSpaceWACategoryFile: OrgSpaceWidgetAddBaseParams;
};

export type OrgSpaceWidgetAddRouteKey = keyof OrgSpaceWidgetAddDrawerParamList;

type OrgSpaceWidgetAddRouteProp<T extends OrgSpaceWidgetAddRouteKey> =
  RouteProp<OrgSpaceWidgetAddDrawerParamList, T>;
type OrgSpaceWidgetAddNavigationProp<T extends OrgSpaceWidgetAddRouteKey> =
  CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"OrgSpaceWidgetAdd">,
    DrawerNavigationProp<OrgSpaceWidgetAddDrawerParamList, T>
  >;

export type OrgSpaceWidgetAddScreenProps<T extends OrgSpaceWidgetAddRouteKey> =
  {
    navigation: OrgSpaceWidgetAddNavigationProp<T>;
    route: OrgSpaceWidgetAddRouteProp<T>;
  };

export const OrgSpaceWidgetAddDrawer =
  createDrawerNavigator<OrgSpaceWidgetAddDrawerParamList>();
